import { CallDirection } from "@redotech/redo-model/support/voice/voice-types";
import { TeamNoticeEventType } from "@redotech/redo-model/team-notifications/team-notifications";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { StreamMessageSchema } from "../../../stream/redis-stream-types";

const BaseTeamEventSchema = z.object({ type: createEnum(TeamNoticeEventType) });

const CallEventSchema = BaseTeamEventSchema.extend({
  type: createEnum([
    TeamNoticeEventType.CALL_CONNECTED,
    TeamNoticeEventType.CALL_HANGUP,
  ]),
  supportAgentCallSessionId: z.string(),
  customerCallControlId: z.string(),
  customerId: z.string(),
  customerNumber: z.string(),
  direction: createEnum(CallDirection),
  agentId: z.string().optional(),
});

const EndRingingEventSchema = BaseTeamEventSchema.extend({
  type: z.literal(TeamNoticeEventType.END_RINGING),
  customerCallControlId: z.string(),
});

const ConversationUpdateEventSchema = BaseTeamEventSchema.extend({
  type: z.literal(TeamNoticeEventType.SOME_CONVERSATIONS_UPDATED),
  conversationIds: z.array(z.string()),
});

const SimpleEventSchema = BaseTeamEventSchema.extend({
  type: createEnum([
    TeamNoticeEventType.RELOAD_ALL_CONVERSATIONS,
    TeamNoticeEventType.CONNECTION_MADE,
    TeamNoticeEventType.CONNECTION_ABORTED,
    TeamNoticeEventType.ERROR_EVENT,
    TeamNoticeEventType.USER_AVAILABILITY_UPDATED,
  ]),
});
export const TeamEventSchema = z.discriminatedUnion("type", [
  CallEventSchema,
  EndRingingEventSchema,
  ConversationUpdateEventSchema,
  SimpleEventSchema,
]);

export const watchTeamEvents = unaryStreamRpc({
  name: "watchTeamEvents",
  input: z.object({
    currentId: z.string().optional(), // Optional current ID for resuming the stream
  }),
  output: StreamMessageSchema(TeamEventSchema),
});
